import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=4dc6d272&scoped=true&lang=pug"
import script from "./InfoWidget.vue?vue&type=script&lang=ts"
export * from "./InfoWidget.vue?vue&type=script&lang=ts"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&id=4dc6d272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6d272",
  null
  
)

export default component.exports